import { Box, makeStyles, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ParcelList from "./ParcelList";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOpenSelfPickupManualDialog, handleOpenSelfPickupManualDialog, showAlertSnackbar } from "../../reducers/uiSlice";
import { handleScannedTnos } from "../../actions/selfPickupActions";
import UniDialogPad from "../Common/UniDialogPad";

const useStyles = makeStyles((theme) => ({
    cardGroupStyle: {
        position: 'fixed',
        top: 270,
        backgroundColor: '#3A3A3A',
        overflow: 'scroll',
        overflowX: 'hidden'
    }
}))

function ParcelScanSection() {
    const classes = useStyles();
    const { t } = useTranslation('selfPickup');
    const dispatch = useDispatch();

    const barcodeWidth = window.innerWidth;
    const scrollStyle = { height: 'calc(100vh - 392px)', width: barcodeWidth }

    const validOrders = useSelector(state => state.selfPickupReducer.validOrders);
    const manualOpen = useSelector(getOpenSelfPickupManualDialog) || false;

    const [resList, setResList] = useState(validOrders);
    const [manualInput, setManualInput] = useState('');
    const [scannedList, setScannedList] = useState([]);

    const handleOrderScanned = (type, value) => {
        let resObj = {};
        const resExist = (ele) => {
            if (ele.orders.tno === (type === 'scan' ? value.trim() : manualInput)) {
                resObj = ele;
                return true;
            } else {
                return false;
            }
        };
        let resValue = resList.some(resExist);
        if (resValue) {
            setScannedList((prev) => [
                ...prev,
                resObj
            ])
            dispatch(showAlertSnackbar({ title: t('success'), message: t('scanned_successfully'), type: 'success' }));
            dispatch(handleOpenSelfPickupManualDialog(false));
            setManualInput('');
        } else {
            dispatch(showAlertSnackbar({ title: t('wrong_package'), message: t('no_package'), type: 'error' }));
        }
    }

    const handleCloseManualDialog = () => {
        setManualInput('');
        dispatch(handleOpenSelfPickupManualDialog(false));
    }

    useEffect(() => {
        setResList(validOrders);
    }, [validOrders])

    useEffect(() => {
        let clone = [...scannedList];
        if (clone?.length > 0) {
            let cloneNoDuplicate = clone.reduce((unique, o) => {
                if (!unique.some(obj => obj.orders.tno === o.orders.tno)) {
                    unique.push(o);
                }
                return unique;
            }, [])
            dispatch(handleScannedTnos(cloneNoDuplicate));
        } 
    }, [scannedList])

    return (
        <Box>
            <div style={{ marginTop: -400 }}>
                <BarcodeScannerComponent
                    width={barcodeWidth}
                    onUpdate={(err, result) => {
                        if (result) {
                            dispatch(showAlertSnackbar({ title: t('success'), message: t('scan_success'), type: 'success' }))
                            handleOrderScanned('scan', result.text)
                        }
                    }}
                    cameraProps={{ ratio: '1:1' }}
                />
            </div>
            <div
                className={classes.cardGroupStyle}
                style={scrollStyle}
            >
                <ParcelList list={resList} type={'scan'} scannedList={scannedList} />
            </div>
            <UniDialogPad
                open={manualOpen}
                autoClose={false}
                onClose={handleCloseManualDialog}
                onFinish={() => handleOrderScanned('input')}
                title={t('tracking_number')}
                cancelButtonText={t('cancel')}
                finishButtonText={t('search')}
                maxwidth='sm'
                fullWidth
            >
                <TextField
                    variant="outlined"
                    style={{ marginTop: 10 }}
                    fullWidth
                    placeholder={t('enter_tracking_number')}
                    onChange={(e) => setManualInput(e.target.value)}
                />
            </UniDialogPad>
        </Box>
    )
}

export default ParcelScanSection;